import { Avatar, Grid, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { Arrow } from 'Images';
import { Link as RouterLink } from 'react-router-dom';
import { RoutesConfig } from 'Routes';

interface INumOfExpiredMedications {
  numOfExpiredMedications: number;
}

export const ExpiredMedicationsTitle = ({
  numOfExpiredMedications,
}: INumOfExpiredMedications) => {
  const medicationsDictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsHistory
  );

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  return (
    <Stack mt={3}>
      <Link
        component={RouterLink}
        to={RoutesConfig.MEDICATION_AND_PRESCRIPTIONS_LOBBY.PATH}
      >
        <Grid container alignItems='center'>
          <Avatar
            src={Arrow}
            alt={generalDictionary.rightArrow}
            sx={{
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              transform: 'rotate(180deg)',
              marginRight: '4px',
            }}
          />
          {medicationsDictionary.titleLink}
        </Grid>
      </Link>
      <Typography
        paragraph
        variant='h1'
        fontWeight={700}
        sx={{ fontSize: '25px', mb: 1, mt: 4 }}
        tabIndex={0}
      >
        {dictionary.thereAreNumberOfMedicationsThatRequiresYourAttention(
          numOfExpiredMedications
        )}
      </Typography>
      <Typography
        paragraph
        sx={{ fontSize: '18px', lineHeight: '24px', mb: 3 }}
      >
        {
          dictionary.attachingDocumentsThatAreRelevantWillHelpUsTakeCareOfYourRequestsFaster
        }
      </Typography>
    </Stack>
  );
};
